<template>
    <div class="position-relative w-100" style="height: 390px;">
        <div class="navbar-wrapper">
            <HeroNavbar :lightToggler="true"/>

        </div>
        <img src="@/assets/images/hero_cover.png" alt="Hero Background"
            class="img-fluid w-100 h-100 object-fit-cover" />
        <!-- Black overlay -->
        <div class="overlay"></div>

        <div class="position-absolute top-50 start-50 translate-middle text-white text-center">

            <h1 class="fw-bold">
                {{ breadcrumbData.title }}
            </h1>
            <p class="content">
               <router-link :to="breadcrumbData.subtitle.first_href" class="breadcrumblink"> {{ breadcrumbData.subtitle.first_text }} </router-link> 
                &gt;
                {{ breadcrumbData.subtitle.second_text }} 
            </p>
        </div>
    </div>
</template>

<script>
import HeroNavbar from './HeroNavbar.vue';


export default {
    name: 'pagesHero',
    components: {
        HeroNavbar
    },
    props : ['title','subtitle','breadcrumbData']
}
</script>

<style scoped>
.object-fit-cover {
    object-fit: cover;
}
.navbar-wrapper {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10; /* Ensure it's above the overlay */
}

/* Black overlay */
.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
}

.content {
    margin-top: 25px;
    font-size: 18px;
    font-weight: 400;
}

h1 {
    font-weight: 500;
    font-size: 36px;
}

.breadcrumblink {
    color: white;
    text-decoration: none;
}

.breadcrumblink:hover {
    color: #BF9F35
}
</style>